import React from 'react';
import { FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
import blogPosts from '../lib/blogposts.js';
import Seo, { SITE_URL } from './Seo';

function formatDate(dateStr) {
    return new Date(dateStr).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
}

const BlogIndex = () => (
    <div className="page pt-32">
        <Seo
            title="Blog | CompressImages.org"
            description="Read tutorials and tips on image compression, web performance, and SEO."
            path="/blog"
            jsonLd={{
                '@context': 'https://schema.org',
                '@type': 'Blog',
                name: 'CompressImages.org Blog',
                url: `${SITE_URL}/blog`,
            }}
        />

        <section className="section-hd">
            <h1>Guides & resources</h1>
            <p>Practical guides on image formats, compression, SEO, and web performance.</p>
        </section>

        <div className="blog-grid">
            {blogPosts.map(({ slug, title, date, author, excerpt }) => (
                <Link key={slug} to={`/blog/${slug}`} className="blog-card">
                    <div className="blog-card-img"><FileText /></div>
                    <div className="blog-meta-row">
                        <span className="blog-tag">Guide</span>
                        <span className="blog-date">{formatDate(date)} · {author}</span>
                    </div>
                    <div className="blog-card-title">{title}</div>
                    <div className="blog-card-sub">{excerpt}</div>
                </Link>
            ))}
        </div>
    </div>
);

export default BlogIndex;
